/**
 * Prenup Status Constants
 * Centralized status definitions for prenup records
 */

/**
 * Sheet status options for dropdown
 */
export const SHEET_STATUS = {
  PENDING_HVD: {
    value: '1',
    label: 'منتظر نتيجة الHVD'
  },
  REPLACE_SAMPLE: {
    value: '2',
    label: 'مطلوب إستبدال العينة'
  },
  READY_PRINT: {
    value: '3',
    label: 'جاهز للطباعة'
  },
  PRINTED: {
    value: '4',
    label: 'تم الطباعة'
  }
};

/**
 * Record status text mapping (from backend status field)
 */
export const RECORD_STATUS_TEXT = {
  pending: 'منتظر نتيجة الHVD',
  approved: 'تم الطباعة',
  rejected: 'مرفوض'
};

/**
 * Get sheet status label by value
 * @param {string} value - Status value
 * @returns {string} Status label
 */
export const getSheetStatusLabel = (value) => {
  const status = Object.values(SHEET_STATUS).find(s => s.value === value);
  return status ? status.label : value;
};

/**
 * Get record status text
 * @param {string} status - Record status (pending/approved/rejected)
 * @returns {string} Status text in Arabic
 */
export const getRecordStatusText = (status) => {
  return RECORD_STATUS_TEXT[status] || status;
};
